<template>
  <BaseAlert v-if="hasRemovedServices" :hg-value="true" hg-type="warning">
    The following services are not supported by {{selectedInspectorName}} and were removed:
    <ul>
      <li v-for="removedService in removedServices" :key="removedService.id">
        <strong>{{removedService.name}}</strong>
      </li>
    </ul>
  </BaseAlert>
</template>

<script>
import { Components } from '@homegauge/vue';
import { mapActions, mapGetters, mapState } from 'vuex';

const { BaseAlert } = Components;

export default {
  components: {
    BaseAlert,
  },
  data() {
    return {
      removedServices: [],
    };
  },
  computed: {
    ...mapState('Appointment', {
      selectedInspectorId: state => state.dateComponentData.inspectorId,
      selectedInspectorName: state => state.dateComponentData.fullName,
      selectedServices: state => state.servicesComponentData.selectedServices,
    }),
    ...mapState('Services', {
      services: state => state.records,
    }),
    ...mapGetters('Services', ['servicesForInspector']),
    hasRemovedServices() {
      return !!(this.removedServices && this.removedServices.length > 0);
    },
  },
  async mounted() {
    const inspectorServices = this.servicesForInspector(this.selectedInspectorId);
    await this.diffSelectedServices(inspectorServices);
  },
  methods: {
    ...mapActions('Appointment', [
      'loadServicesEstimate',
      'removeService',
    ]),
    async diffSelectedServices(inspectorServices) {
      const selectedServiceIds = this.selectedServices.map(s => s.id);

      const inspectorServiceIds = inspectorServices
        .reduce((acc, curVal) => acc.concat(curVal.services), [])
        .map(service => service.id);

      const differingServiceIds = selectedServiceIds
        .filter(serviceId => !inspectorServiceIds.includes(serviceId));

      const differingServices = this.services
        .reduce((acc, curVal) => acc.concat(curVal.services), [])
        .filter(service => differingServiceIds.includes(service.id));

      if (differingServices.length > 0) {
        this.removedServices = differingServices;
      }

      if (differingServiceIds.length > 0) {
        await Promise.all(differingServiceIds.map(serviceId => this.removeService(serviceId)));
        await this.loadServicesEstimate();
      }
    },
  },
};
</script>
